export default "/images/63c07cf543649031caa529a57b2a8e33.avif";